import { Label, LoadingSpinner, Typography } from '@neo4j-ndl/react';
import type { Instance } from '@nx/state';
import { formatDistanceStrict } from 'date-fns';
import React from 'react';

import { kindOfMigration } from './common';

interface Props {
  instance: Instance;
}

export const CloningInProgressSection = ({ instance }: Props) => {
  const showTimeElapsed = () => {
    // We currently have no means of saving elapsed time, but we can have the diff between instance creation and current
    // When doing clone to existing, this will not work, thus we can't show time elapsed for this
    // To determine clone to existing, we have to guess that all migration times bigger than X will most likely be
    // existing instances, not new ones. X set to be a day for now.
    const oneDayInMs = 24 * 60 * 60 * 1000;
    const diff = new Date(instance.createdAt).getTime() - new Date().getTime();
    return Math.abs(diff) < oneDayInMs;
  };

  return (
    <div className="bg-palette-neutral-bg-weak mb-4 mt-3 w-full rounded-3xl">
      <Label className="relative top-[-12px] mr-2" fill="outlined" color={'default'}>
        {kindOfMigration(instance)} migration
      </Label>
      <div className="display-inline float justify mb-6 flex px-8 pb-2 pt-2">
        <LoadingSpinner size={'large'} />
        <div className="px-4">
          <b>Cloning to target instance:</b> {instance.name}
          <br />
          {showTimeElapsed() && (
            <Typography variant={'body-small'}>
              Time elapsed: {formatDistanceStrict(new Date(instance.createdAt), new Date())}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
